(function () {

    'use strict';

    angular.module('iplusjs.validator.vertragsnummer', [
        'lodash',
        'iplusjs.utils.vertrag',
        'iplusjs.utils.misc',
        'iplusjs.utils.identityType',
        'iplusjs.utils.formField',
        'iplusjs.fieldset'
    ])
    .directive('iplusjsVertragsnummerValidator', vertragsnummerValidator);

    vertragsnummerValidator.$inject = [
        '$q',
        '$log',
        'lodash',
        'VertragUtilsService',
        'MiscUtilsService',
        'IdentityTypeUtilsService',
        'FormFieldUtilsService'
    ];
    function vertragsnummerValidator($q, $log, _, VertragUtilsService, MiscUtilsService, IdentityTypeUtilsService, FormFieldUtilsService) {
        return {
            require: ['ngModel', '^?iplusjsFieldset'],
            link: linkFnc
        };

        function linkFnc($scope, $elem, $attrs, ctrls) {
            var $ngModel = ctrls[0],
                fieldsetCtrl = ctrls[1];

            if ($attrs.disabled || $scope.$eval($attrs.ngDisabled) || (fieldsetCtrl && fieldsetCtrl.disabled)) {
                return;
            }

            $scope.$watch(function () {
                return $attrs.iplusjsVertragsnummerValidator;
            }, function (newValue) {
                if (newValue) {
                    $ngModel.$validate();
                }
            });
            $ngModel.$validators.unternehmenVertragsnummerFormat = function (value) {
                var validationValue;

                validationValue = value || $ngModel.$viewValue;

                if (IdentityTypeUtilsService.isIdentityType(validationValue)) {
                    validationValue = IdentityTypeUtilsService.getId(validationValue);
                }

                if (MiscUtilsService.isEmpty(validationValue)) {
                    return true;
                }

                $log.debug('vertragsnummerValidator $validators.unternehmenVertragsnummerFormat', value);

                return IdentityTypeUtilsService.isValid(validationValue, 'vertragsnummer');
            };
            $ngModel.$asyncValidators.vertragsnummer = function (value) {
                var produktNr = $attrs.iplusjsVertragsnummerValidator,
                    kompatibleProdukte = $attrs.ivvKompatibleProdukte === 'true' ? true : false,
                    subtypenBeachten = $attrs.ivvSubtypenBeachten === 'true' ? true : false;

                $log.debug('vertragsnummerValidator $asyncValidators.vertragsnummer', value, produktNr, kompatibleProdukte);

                if (MiscUtilsService.isEmpty(value) || !produktNr) {
                    return $q.resolve();
                }

                return VertragUtilsService.existsVertragsnummer(IdentityTypeUtilsService.toId(value), produktNr, kompatibleProdukte, subtypenBeachten).then(function () {
                    FormFieldUtilsService.renderViewValue($ngModel);

                    return true;
                }).catch(function () {
                    return $q.reject();
                });
            };
        }
    }
})();
